// extracted by mini-css-extract-plugin
export default {"templateHeader":"TemplateHeader_templateHeader__GhWWc","templateName":"TemplateHeader_templateName__LiCIb","changeTemplate":"TemplateHeader_changeTemplate__icKKl"};